import { render, staticRenderFns } from "./group-settings.vue?vue&type=template&id=5b21f98c&scoped=true"
import script from "./group-settings.vue?vue&type=script&lang=js"
export * from "./group-settings.vue?vue&type=script&lang=js"
import style0 from "./group-settings.vue?vue&type=style&index=0&id=5b21f98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b21f98c",
  null
  
)

export default component.exports